"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSOrderDetailsComponent = void 0;
const router_1 = require("@angular/router");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const underscore_1 = require("underscore");
const orderStatus_service_1 = require("../../services/orderStatus.service");
const constants = require("../../util/constants");
class CSOrderDetailsComponent {
    constructor(modalService, orderService, router) {
        this.modalService = modalService;
        this.orderService = orderService;
        this.router = router;
        this.additionalItems = [];
        this.devicesAndAccessories = [];
        this.paymentMethod = constants.paymentMethod;
        this.storePickUpItems = [];
        this.allItems = [];
    }
    ngOnInit() {
        this.getOrderDetails();
        this.getDevicesAndAdditionalItems();
        this.getOrderSidebar = document.getElementById('order-sidebar');
    }
    /**
   * @returns cached order details
   */
    getOrderDetails() {
        if (this.orderService.orderData) {
            this.orderData = this.orderService.orderData;
        }
        else {
            this.router.navigate(['/']);
        }
    }
    /**
   * Print Order Status
   */
    printOrderStatusSection() {
        document.getElementById('order-sidebar').style.display = 'none';
        this.orderStatus = document.querySelector('cs-orderdetails').innerHTML;
        const popupWindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWindow.document.open();
        popupWindow.document.write('<html><head><link href="/resources/css/compiled-css/order-status/order-status.css" rel="stylesheet"/></head><body>' +
            this.orderStatus +
            '<script type="text/javascript">window.print();setTimeout(function() {window.close();}, 500)</script></html>');
        popupWindow.document.close();
        document.getElementById('order-sidebar').style.display = 'block';
    }
    /**
   * Seperate Additional Items from other items
   */
    getDevicesAndAdditionalItems() {
        if (this.orderService.orderData != null) {
            for (const item of this.orderService.orderData.orderItemList) {
                for (const fullFillmentList of this.orderService.orderData
                    .fulFillmentGroupList) {
                    if (fullFillmentList.fulFillmentType === 'DIRECT_FROM_STORE') {
                        this.directStoreOrder = true;
                    }
                    if (fullFillmentList.orderItemId != null) {
                        for (const orderItem of fullFillmentList.orderItemId) {
                            if (item.orderItemId === orderItem) {
                                this.allItems.push(item);
                                if (fullFillmentList.fulFillmentType === 'PICKUP_AT_STORE') {
                                    this.storePickUpItems.push(item);
                                }
                                else if (fullFillmentList.fulFillmentType === 'SHIP') {
                                    this.devicesAndAccessories.push(item);
                                }
                            }
                        }
                    }
                }
            }
            this.additionalItems = underscore_1.difference(this.orderService.orderData.orderItemList, this.allItems);
            this.additionalItems = this.additionalItems.reduce(this.filterOrderItems, []);
        }
    }
    filterOrderItems(orderItems, currentOrderItem) {
        const foundIndex = orderItems.findIndex((orderItem) => orderItem.itemCode === currentOrderItem.itemCode
            && orderItem.itemPrice === currentOrderItem.itemPrice);
        if (foundIndex < 0) {
            orderItems.push(currentOrderItem);
        }
        else {
            orderItems[foundIndex].itemPrice += currentOrderItem.itemPrice;
            orderItems[foundIndex].quantity += currentOrderItem.quantity;
        }
        return orderItems;
    }
}
exports.CSOrderDetailsComponent = CSOrderDetailsComponent;
//# sourceMappingURL=orderdetails.component.js.map